export default __webpack_public_path__ + "static/media/Furniture.bdb1be63.jpeg";